import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from './useAuth';

const UTM_KEY = 'professya_utm';

export function captureUtmFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source');
  if (!source) return;
  try {
    sessionStorage.setItem(UTM_KEY, JSON.stringify({
      utm_source:             source,
      utm_medium:             params.get('utm_medium')      ?? null,
      utm_campaign:           params.get('utm_campaign')    ?? null,
      utm_content:            params.get('utm_content')     ?? null,
      referral_landing_page:  window.location.pathname,
    }));
  } catch { /* ignore */ }
}

export function useUtmCapture(): void {
  const { user } = useAuth();

  useEffect(() => {
    // Always capture UTM from URL when present
    captureUtmFromUrl();
  }, []);

  useEffect(() => {
    if (!user) return;
    // Save stored UTM to profile (once, on login/signup)
    try {
      const stored = sessionStorage.getItem(UTM_KEY);
      if (!stored) return;
      const utm = JSON.parse(stored) as Record<string, string | null>;
      sessionStorage.removeItem(UTM_KEY);
      // Only update if utm_source not already saved
      supabase
        .from('profiles')
        .select('utm_source')
        .eq('id', user.id)
        .maybeSingle()
        .then(({ data }) => {
          if (data?.utm_source) return; // already recorded
          supabase.from('profiles').update(utm).eq('id', user.id);
        });
    } catch { /* ignore */ }
  }, [user?.id]);
}
